import React, { useState } from "react";
import calqueLogo from "../assets/images/calque_prototype.png";
import userIcon from "../assets/images/icons/user_icon.png";
import unlockIcon from "../assets/images/icons/unlock_icon.png";
import "../styles/authStyles/login.css";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { NavLink, useNavigate } from "react-router-dom";
import Button from "@mui/material/Button";
import { Formik, Form, ErrorMessage } from "formik";
import config from "../config/Config";
import CircularProgress from "@mui/material/CircularProgress";

export default function Login() {
  const [showPassword, setShowPassword] = useState(false);
  const [nonFieldErrors, setNonFeildErrors] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const navigate =useNavigate();
  const initialValues = {
    username: "",
    password: "",
  };

  const validate = (values) => {
    let errors = {};

    if (!values.username || values.username.trim() === "") {
      errors.username = "Please enter  username";
    }
    if (!values.password || values.password.trim() === "") {
      errors.password = "Please enter  password";
    } else if (values.password.length <= 6) {
      errors.password = "Must be more than 6 characters";
    }
    return errors;
  };

  const onSubmit = (values) => {
    setIsLoading(true)
    fetch(`${config.baseUrl}login/`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        username: values.username,
        password: values.password,
      }),
    })
      .then((res) => res.json())
      .then((results) => {
        if (results.non_field_errors) { // For invalid credentials
          setNonFeildErrors(results.non_field_errors[0])
          setIsLoading(false)
        } else if (results) {
          localStorage.setItem("access_token", results.access_token);
          localStorage.setItem("user_id", results.user_info.id);
          localStorage.setItem("user_info", JSON.stringify(results.user_info));
          setIsLoading(false);
          setNonFeildErrors('')
          navigate('/application-listing')
        } else if (!results) {
          localStorage.setItem("access_token", results.access_token);
          localStorage.setItem("user_id", results.user_info.id);
          setIsLoading(false)
          setNonFeildErrors('')
          navigate('/')
        }
      });
  };

  const handleIconClick = () => {
    setShowPassword((prev) => !prev);
  };

  return (
    <div>
      <div className="login-container">
        <div className="calque-prototype-container">
          <img src={calqueLogo} alt="Calque Logo" className="calque-prototype-image"
          />
        </div>
        <div className="login-form-outer-container">
          <Formik
            initialValues={initialValues}
            validate={validate}
            onSubmit={onSubmit}
          >
            {({ values,errors,touched, handleChange, handleBlur,handleSubmit, isSubmitting,}) => (
              <form onSubmit={handleSubmit}>
                <Box className="login-form-inner-container">
                  <TextField
                    margin="normal"
                    fullWidth
                    id="username"
                    name="username"
                    type="text"
                    autoComplete="off"
                    placeholder="Username"
                    className="custom-text-field"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values?.username}
                    slotProps={{
                      htmlInput: {
                          maxLength: 50,
                      },
                      input: {
                        startAdornment: (
                          <InputAdornment position="start">
                            <img
                              src={userIcon}
                              alt="user icon"
                              className="input-icons"
                            />
                          </InputAdornment>
                        ),
                      },
                    }}
                    variant="standard"
                  />
                  <ErrorMessage name="username" component="div" className="error"/>
                  <TextField
                    margin="normal"
                    fullWidth
                    id="password"
                    name="password"
                    type={showPassword ? "text" : "password"}
                    autoComplete="off"
                    placeholder="Password"
                    className="custom-text-field"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values?.password}
                    slotProps={{
                      htmlInput: {
                          maxLength: 50,
                      },
                      input: {
                        startAdornment: (
                          <InputAdornment position="start">
                            <img
                              src={unlockIcon}
                              alt="unlock icon"
                              className="input-icons"
                            />
                          </InputAdornment>
                        ),
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton onClick={handleIconClick} edge="end">
                              {showPassword ? (
                                <Visibility className="input-icons" />
                              ) : (
                                <VisibilityOff className="input-icons" />
                              )}
                            </IconButton>
                          </InputAdornment>
                        ),
                      },
                    }}
                    variant="standard"
                  />
                  <ErrorMessage name="password" component="div" className="error" />
                  <div>
                    <p className="forgot-title">
                      <NavLink to="/forgot-password" style={{ textDecoration: 'none', color: 'white' }}>
                      <span>Forgot Password ?</span>
                      </NavLink>
                    </p>
                  </div>
                  <div className="error non-field-error">
                    <span>{nonFieldErrors}</span>
                  </div>
                  <div className="d-flex justify-center align-center mt-10">
                    <Button
                      className="login-btn"
                      type="submit"
                      variant="contained"
                      disabled={isLoading}
                    >
                     {isLoading === false ? "Login" : (
                        <CircularProgress className="circular_spiner" size={24} sx={{color:"white"}} />
                    )}
                    </Button>
                  </div>
                </Box>
              </form>
            )}
          </Formik>
        </div>
      </div>
    </div>
  );
}
